<template>
  <div class="container-fluid full-width-page-wrapper">
    <div class="row">
      <div class="col my-auto">
        <h3 class="page-title">Decisions</h3>
      </div>
    </div>

    <!-- Select Award Type Dropdown -->
    <div class="row mb-4 align-items-center">
      <div class="col-4">
        <ifac-search-dropdown
          :options="awards"
          currentType="object"
          currentValue="name"
          @selected="handleSelectedAward"
          placeholder="Select an award"
        />
      </div>
      <div class="col-md-3" v-if="selectedAward && awardReport?.can.view">
        <router-link :to="awardReportRoute" class="btn btn-secondary" style="padding: 0.75rem">View Award Report</router-link>
      </div>
    </div>

    <!-- Nominations Table -->
    <NominationsTable :award="selectedAward"/>

    <!-- Award Reports Table -->
    <div class="mt-4" v-if="awardsReports?.length">
      <h3 class="mb-4">Award Reports</h3>
      <ReportsTable @awardClosed="handleAwardClosed" :award-reports="awardsReports"/>
    </div>
  </div>
</template>

<script>
import NominationsTable from '@/views/areas/awards/decisions/partials/NominationsTable.vue';
import ReportsTable from '@/views/areas/awards/decisions/partials/ReportsTable.vue';
import Awards from '@/services/Api/Awards/Awards';
import Reports from '@/services/Api/Awards/Reports';
import { IfacSearchDropdown } from '@ifac/ui';

export default {
  name: 'AwardsDecisions',
  components: {
    IfacSearchDropdown,
    NominationsTable,
    ReportsTable,
  },
  data() {
    return {
      loading: null,
      groups: [],
      awards: [],
      awardsReports: [],
      selectedAward: null,
    };
  },
  created() {
    this.fetchAwards();
    this.fetchAwardsReports();
  },
  methods: {
    fetchAwards() {
      Awards.all().then((response) => {
        this.awards = response.data.data;
      });
    },
    fetchAwardsReports() {
      const params = {
        type: 'award',
      };

      Reports.all(params).then((response) => {
        this.awardsReports = response.data.data;
      });
    },
    handleSelectedAward(award) {
      this.selectedAward = award || null;
    },
    handleAwardClosed() {
      this.fetchAwardsReports();
    },
  },
  computed: {
    awardReport() {
      return this.awardsReports.find((r) => r.reportable.id === this.selectedAward.id);
    },
    awardReportRoute() {
        return {
          name: 'ReportsEdit',
          params: {
            report: this.awardReport.id,
          },
        };
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/base/_variables.scss';
@import '@/assets/styles/base/_mixins.scss';
</style>
